export default __webpack_public_path__ + "static/media/icon.ccc360b5.png";